import { render, staticRenderFns } from "./CreateAppointmentDialog.vue?vue&type=template&id=4509fc9c"
import script from "./CreateAppointmentDialog.vue?vue&type=script&lang=js"
export * from "./CreateAppointmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports